<template>
  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Sunting
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
    <z-input label="Name" v-model="form.name" name="name" :validators="[validators.required]" />

    <z-input class="mt3" label="Email" v-model="form.email" name="email" :validators="[validators.required]" />

    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>

    
  </w-dialog>
  
  <z-table
    ref="tbluser"
    :title="title"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class="white--bg"
    :loading="loading"
  >
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <w-icon>fal fa-check-square</w-icon>
      </template>
      <template v-else>
      {{ label }}
      </template>
      
    </template>

    <template #item-cell.viaroles="{ item, label, header, index }">
      
        <input 
          type="checkbox"
          disabled
          v-model="viaroles"
          :id="item.id"
          :value="item.id"
        />
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      
        <input 
          type="checkbox"
          v-model="selected"
          :id="item.id"
          :value="item.id"
        />
    </template>

  </z-table>

    <div class="mt2 text-right">
      <w-button 
        type="submit"
        class="text-bold" 
        bg-color="z-primary-grad"
        :loading="loading"
        @click="submit"
      >
        <w-icon>fal fa-save</w-icon>&nbsp;Simpan
      </w-button>
    </div>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    user: [Array, Object],
    items: [Array, Object],
    viaroles:  [Array, Object],
    selected:  [Array, Object],
    parent: {
      type: String,
      default: 'admin.user.update'
    },
    which: String,
    title: String,
  },
  data() {
    return {
      resourceurl: 'admin.permission',
      loading: false,
      form: {
        id: 0,
        name: '',
        email: ''
      }
    }
  },
  methods: {
    submit() {
      this.form.selected = this.selected
      this.loading = true
      this.$zcomm.update(this.parent + this.which, this.user.id, this.form)
      .then(res => {
        this.loading = false
      })
      window.location.reload();
    }
  },
  watch: {
    selected: function (v) {
      console.log(v)
      this.$emit('update', this.selected);
      
    }
  },
  mounted() {
    // override default setting
    // console.log('loading')
  }
}
</script>
